export const commandToolbarLabel = "xCa";
export default {commandToolbarLabel};